import React, { useEffect, useState } from 'react';
import appLogo from '../../../../assets/logo_light.svg';

interface SplashScreenProps {
  onComplete: () => void;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Simulate initialization time
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onComplete, 500); // Wait for fade-out animation
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-gradient-to-br from-pos-dark via-pos-primary to-pos-secondary transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="text-center animate-fade-in-up">
        {/* Logo Icon */}
        <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-3xl bg-white bg-opacity-20 backdrop-blur-lg shadow-2xl">
          <img src={appLogo} alt="Logo" className="h-14 w-14" />
        </div>

        {/* App Name */}
        <h1 className="text-4xl font-bold tracking-tight text-white mb-2 font-google-sans">
          SmartPOS Cloud
        </h1>
        <p className="text-lg text-white text-opacity-80">
          Empowering your business
        </p>

        {/* Loading Indicator */}
        <div className="mt-12 flex justify-center">
          <div className="flex space-x-2">
            <div className="h-2 w-2 rounded-full bg-white animate-bounce [animation-delay:-0.3s]" />
            <div className="h-2 w-2 rounded-full bg-white animate-bounce [animation-delay:-0.15s]" />
            <div className="h-2 w-2 rounded-full bg-white animate-bounce" />
          </div>
        </div>
      </div>
    </div>
  );
};
